module.exports = __webpack_public_path__ + "img/home_tstelagawarna.74b685aa.png";